export default __webpack_public_path__ + "static/peter-headshot-6ca2eb02b4a0218d55a8f26ac091a5d0.jpg";